export const OrganizationBankAccountForm = [
    {
        "key": "account_name",
        "type": "input",
        "templateOptions": {
            "attributes": {
                "autofocus": '',
                "autocomplete": "off",
            },
            "type": "text",
            "label": "Account Name",
            "placeholder": "Account Name",
            "required": true
        }
    },
    {
        "key": "account_number",
        "type": "input",
        "templateOptions": {
            "attributes": {
                "autofocus": '',
                "autocomplete": "off",
            },
            "type": "number",
            "label": "Account Number",
            "placeholder": "Account Number",
            "required": true
        }
    },
    {
        "key": "bank_name",
        "type": "input",
        "templateOptions": {
            "attributes": {
                "autofocus": '',
                "autocomplete": "off",
            },
            "type": "text",
            "label": "Bank Name",
            "placeholder": "Bank Name",
            "required": true
        }
    },
    {
        "key": "branch_name",
        "type": "input",
        "templateOptions": {
            "attributes": {
                "autofocus": '',
                "autocomplete": "off",
            },
            "type": "text",
            "label": "Branch Name",
            "placeholder": "Branch Name",
            "required": true
        }
    },
]